export const registrationResources = {
  'registration.userRegistration': 'User Registration',
  'registration.partnerSetup': 'Partner Setup',
  'registration.confirmPassword': 'Confirm Password',
  'registration.registrationSuccess.title': 'Registration Successful',
  'registration.registrationSuccess.subTitle': 'Please login to begin setting up your account.',
  'registration.validation.emailRequired': 'Email address is required.',
  'registration.validation.firstNameRequired': 'First name is required',
  'registration.validation.lastNameRequired': 'Last name is required',
  'registration.validation.passwordRequired': 'Password is required',
  'registration.validation.passwordComplexity': 'Password must be at least 8 characters.',
  'registration.validation.passwordEmailVerify': 'Password must not include email',
  'registration.validation.passwordASCII': 'Password must only use standard ASCII characters',
  'registration.validation.passwordMaxComplexity': 'Password cannot exceed 64 characters',
  'registration.validation.passwordMismatch': 'Passwords do not match.',
  'registration.firstName': 'First Name',
  'registration.lastName': 'Last Name',
  'registration.password': 'Password',
  'registration.validation.partnerNameRequired': 'Partner name is required.',
  'registration.partnerName': 'Partner Name',
  'registration.country': 'Country',
  'registration.partnerType': 'Partner Type',
  'registration.returnToLogin': 'Return to Login',
  'registration.changePassword': 'Change Password',
  'registration.expiredChangePasswordLink': 'This link can no longer be used to complete your password change request.',
  'registration.resetPassword': 'Reset Password',
  'registration.passwordResetEmailSent':
    'If the email address you entered was for a valid user, you will receive an email with instructions to reset your password.',
  'registration.passwordExpired': 'Your password has expired.  You must reset your password to login.',
};

export type RegistrationResourceKey =
  | 'registration.userRegistration'
  | 'registration.partnerSetup'
  | 'registration.confirmPassword'
  | 'registration.registrationSuccess.title'
  | 'registration.registrationSuccess.subTitle'
  | 'registration.validation.emailRequired'
  | 'registration.validation.firstNameRequired'
  | 'registration.validation.lastNameRequired'
  | 'registration.validation.passwordRequired'
  | 'registration.validation.passwordComplexity'
  | 'registration.validation.passwordEmailVerify'
  | 'registration.validation.passwordASCII'
  | 'registration.validation.passwordMaxComplexity'
  | 'registration.validation.passwordMismatch'
  | 'registration.lastName'
  | 'registration.password'
  | 'registration.validation.partnerNameRequired'
  | 'registration.partnerName'
  | 'registration.country'
  | 'registration.partnerType'
  | 'registration.returnToLogin'
  | 'registration.changePassword'
  | 'registration.expiredChangePasswordLink'
  | 'registration.resetPassword'
  | 'registration.passwordResetEmailSent'
  | 'registration.passwordExpired';
